export enum UsageLogsColumnsOptions {
  ENTITY = 'Entity',
  CUSTOMER = 'Customer',
  USAGE_PRODUCT = 'Product',
  DATE = 'Date',
  SUB_ACTIVITY = 'Sub Activity',
  QUANTITY = 'Quantity',
  CURRENCY = 'Currency',
  PO_NUMBER = 'PO Number',
}

export enum UsageLogsMappingType {
  RECEIVED = 'received',
  FILE = 'file',
  FORMULA = 'formula',
}
